import React from "react";

export default function Icons({ icon }) {
	switch (icon) {
		case "ntx-media":
			return (
				<svg
					width={777}
					height={132}
					viewBox="0 0 777 132"
					fill="currentColor"
					xmlns="http://www.w3.org/2000/svg">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M698.408 1.94002L773.456 57.332C775.706 59.5824 776.97 62.634 776.97 65.816C776.97 68.998 775.706 72.0497 773.456 74.3L698.443 130.454C697.377 131.252 696.11 131.738 694.784 131.856C693.457 131.975 692.124 131.722 690.933 131.126C689.742 130.53 688.741 129.614 688.042 128.481C687.341 127.348 686.971 126.043 686.971 124.711V124.211C686.971 123.085 687.236 121.974 687.745 120.97C688.254 119.965 688.992 119.094 689.9 118.428L751.476 73.247C753.444 71.2781 754.549 68.6083 754.549 65.8245C754.549 63.0408 753.444 60.371 751.476 58.402L689.922 13.532C689.009 12.8659 688.266 11.9933 687.753 10.9853C687.241 9.97738 686.975 8.86262 686.975 7.73201V7.71202C686.975 6.38446 687.343 5.08289 688.039 3.9522C688.734 2.8215 689.73 1.90605 690.916 1.30776C692.101 0.709459 693.429 0.451768 694.751 0.563401C696.074 0.675019 697.34 1.15158 698.408 1.94002ZM559.378 11.725H550.937L550.941 53.49C548.238 48.9689 544.346 45.2762 539.69 42.814C535.012 40.4744 529.847 39.2718 524.617 39.304C513.41 39.4947 505.143 43.4827 499.817 51.268C494.446 59.006 491.761 68.415 491.761 79.495C491.665 90.911 494.258 100.344 499.54 107.795C504.867 115.34 513.363 119.209 525.03 119.4C530.181 119.24 535.214 117.82 539.69 115.265C544.399 112.755 548.208 108.84 550.59 104.065H550.936V117.325H559.378V11.725ZM544.328 56.579C548.733 62.6532 550.937 70.1609 550.937 79.102C550.936 88.3824 548.825 96.0575 544.606 102.127C540.338 108.298 534.123 111.432 525.96 111.527C522.59 111.627 519.24 110.97 516.158 109.605C513.076 108.239 510.339 106.199 508.149 103.636C503.51 98.6153 501.052 91.2983 500.774 81.685C500.487 71.9283 502.436 63.75 506.619 57.15C510.699 50.5987 517.146 47.275 525.96 47.179C533.844 47.3717 539.967 50.505 544.328 56.579ZM310.764 117.326H302.311V41.313H310.778V52.713H311.053C316.259 43.869 324.092 39.3993 334.553 39.304C341.48 39.4 346.568 40.8094 349.815 43.532C353.047 46.3005 355.473 49.8895 356.837 53.921C362.237 44.1763 370.5 39.304 381.628 39.304C386.929 39.304 391.132 40.1157 394.239 41.739C397.217 43.2417 399.666 45.6157 401.261 48.545C402.891 51.5125 404.006 54.7343 404.561 58.074C405.041 61.8041 405.28 65.5612 405.277 69.322V117.322H396.82V64.808C396.82 59.3153 395.687 55.0153 393.42 51.908C391.058 48.756 386.718 47.18 380.401 47.18C373.552 47.18 367.765 50.0697 363.04 55.849C361.051 58.7439 359.741 62.0503 359.207 65.522C358.414 69.0984 358.001 72.7487 357.977 76.412V117.324H349.536V64.808C349.536 59.3153 348.403 55.0153 346.136 51.908C343.772 48.756 339.432 47.18 333.115 47.18C326.315 47.18 320.552 50.073 315.826 55.859C313.836 58.7594 312.505 62.0604 311.926 65.53C311.179 69.1124 310.791 72.7605 310.768 76.42L310.764 117.326ZM424.934 81.354C424.934 89.7847 427.018 96.8514 431.187 102.554C435.354 108.446 441.536 111.44 449.735 111.535C461.452 111.44 468.886 105.596 472.035 94.005H481.553C479.849 100.859 476.269 107.104 471.215 112.038C466.173 116.857 459.027 119.313 449.776 119.408C438.12 119.217 429.541 115.348 424.037 107.803C418.529 100.448 415.823 91.0633 415.919 79.648C415.919 68.1847 418.949 58.632 425.008 50.99C430.881 43.396 439.137 39.5037 449.774 39.313C470.679 39.5037 481.455 53.519 482.103 81.359L424.934 81.354ZM473.091 74.061C473.091 66.3203 471.142 59.9647 467.245 54.994C463.256 49.8813 457.433 47.2773 449.777 47.182C442.262 47.278 436.462 49.93 432.377 55.138C428.164 60.6196 425.583 67.1784 424.931 74.061H473.091ZM577.188 24.757V11.725H586.5V24.757H577.188ZM577.632 117.326V41.313H586.072V117.326H577.632ZM641.261 72.118C639.081 72.5013 637.132 72.812 635.416 73.05L623.584 74.65C606.443 77.0854 597.872 84.7223 597.872 97.561C597.964 104.862 600.487 110.28 605.44 113.813C610.297 117.582 616.308 119.554 622.453 119.397C627.673 119.432 632.838 118.328 637.587 116.163C642.337 113.997 646.557 110.821 649.953 106.857C650.01 109.292 650.477 111.7 651.335 113.98C652.21 116.116 654.005 117.469 656.722 118.039C657.969 118.324 659.243 118.468 660.522 118.467C661.888 118.46 663.243 118.218 664.527 117.75C665.723 117.464 666.621 117.225 667.221 117.034V110.156C663.7 111.399 661.315 111.542 660.065 110.586C658.717 109.682 658.115 107.582 658.259 104.286V62.877C658.119 54.1844 655.552 48.023 650.559 44.393C645.522 41.0023 639.188 39.307 631.559 39.307C623.374 39.307 616.507 41.193 610.959 44.965C605.364 48.9737 602.127 55.4447 601.249 64.378H609.935C610.907 57.8333 613.246 53.2713 616.952 50.692C620.75 48.2553 625.568 47.085 631.405 47.181C638.075 47.277 642.823 48.7103 645.649 51.481C647.056 52.9561 648.151 54.7004 648.867 56.609C649.583 58.5176 649.907 60.5513 649.818 62.588C649.809 64.0783 649.669 65.5649 649.401 67.031C649.208 67.769 648.869 68.4605 648.402 69.064C647.936 69.6675 647.353 70.1706 646.687 70.543C644.915 71.1867 643.103 71.7128 641.261 72.118ZM638.824 80.396C642.582 79.8093 646.267 78.8234 649.816 77.455L649.818 89.363C649.632 97.015 646.873 102.587 641.539 106.078C636.03 109.765 629.521 111.668 622.894 111.53C618.942 111.602 615.077 110.367 611.9 108.015C608.652 105.768 606.983 102.396 606.892 97.899C607.076 87.9037 614.009 82.5 627.692 81.688C631.426 81.494 635.145 81.0625 638.824 80.396ZM741.621 59.677L698.392 27.954C697.323 27.1695 696.058 26.6966 694.736 26.5879C693.415 26.4792 692.089 26.7388 690.906 27.338C689.724 27.9372 688.73 28.8526 688.036 29.9823C687.342 31.1121 686.975 32.4121 686.975 33.738C686.975 34.8642 687.24 35.9747 687.749 36.9794C688.258 37.9841 688.996 38.8548 689.904 39.521L718.786 60.715C720.14 62.0689 720.899 63.9047 720.899 65.819C720.899 67.7332 720.14 69.5691 718.786 70.923L689.9 92.117C688.992 92.7835 688.254 93.6544 687.745 94.6592C687.236 95.6641 686.971 96.7746 686.971 97.901C686.971 99.2268 687.338 100.527 688.033 101.656C688.727 102.786 689.72 103.701 690.903 104.3C692.085 104.899 693.411 105.159 694.732 105.05C696.054 104.941 697.319 104.468 698.388 103.684L741.617 71.962C743.247 70.3334 744.163 68.1242 744.164 65.8203C744.164 63.5164 743.25 61.3066 741.621 59.677ZM707.641 62.006L698.392 55.219C697.323 54.4347 696.058 53.9618 694.737 53.853C693.416 53.7441 692.09 54.0035 690.908 54.6024C689.725 55.2012 688.731 56.1161 688.037 57.2454C687.343 58.3747 686.976 59.6744 686.975 61V70.6C686.975 71.9258 687.342 73.2257 688.037 74.3553C688.73 75.4849 689.724 76.4001 690.907 76.9991C692.09 77.5982 693.415 77.8578 694.736 77.749C696.058 77.6402 697.323 77.1674 698.392 76.383L707.641 69.596C708.646 68.5888 709.211 67.224 709.211 65.801C709.211 64.378 708.646 63.0131 707.641 62.006ZM22.8081 12.184H0.344238V115H21.5122V46.168H21.8003L64.5684 115H87.1763V12.184H66.0083V81.16H65.7202L22.8081 12.184ZM99.0146 31.192H129.831V115H152.438V31.192H183.254V12.184H99.0146V31.192ZM187.19 12.184L220.31 61.144L184.454 115H209.798L232.694 79.432L255.158 115H282.086L246.23 61.288L279.206 12.184H254.438L233.558 45.016L213.398 12.184H187.19Z"
						fill="currentColor"
					/>
				</svg>
			);
			break;

		case "search":
			return (
				<svg
					aria-hidden="true"
					focusable="false"
					data-prefix="fas"
					data-icon="search"
					role="img"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 512 512"
					className="svg-inline--fa fa-search fa-w-16">
					<path
						fill="currentColor"
						d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
						className
					/>
				</svg>
			);

		case "download":
			return (
				<svg
					fill="currentColor"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24">
					<path d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
				</svg>
			);

		case "image":
			return (
				<svg
					fill="currentColor"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24">
					<path d="M8.5,13.5L11,16.5L14.5,12L19,18H5M21,19V5C21,3.89 20.1,3 19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19Z" />
				</svg>
			);

		case "video":
			return (
				<svg
					fill="currentColor"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24">
					<path d="M17,10.5V7A1,1 0 0,0 16,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16A1,1 0 0,0 17,17V13.5L21,17.5V6.5L17,10.5Z" />
				</svg>
			);

		case "note-text":
			return (
				<svg
					fill="currentColor"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24">
					<path d="M14,10H19.5L14,4.5V10M5,3H15L21,9V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3M5,12V14H19V12H5M5,16V18H14V16H5Z" />
				</svg>
			);

		case "brush":
			return (
				<svg
					fill="currentColor"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24">
					<path d="M20.71,4.63L19.37,3.29C19,2.9 18.35,2.9 17.96,3.29L9,12.25L11.75,15L20.71,6.04C21.1,5.65 21.1,5 20.71,4.63M7,14A3,3 0 0,0 4,17C4,18.31 2.84,19 2,19C2.92,20.22 4.5,21 6,21A4,4 0 0,0 10,17A3,3 0 0,0 7,14Z" />
				</svg>
			);

		case "file-pdf-box":
			return (
				<svg
					fill="currentColor"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24">
					<path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M9.5 11.5C9.5 12.3 8.8 13 8 13H7V15H5.5V9H8C8.8 9 9.5 9.7 9.5 10.5V11.5M14.5 13.5C14.5 14.3 13.8 15 13 15H10.5V9H13C13.8 9 14.5 9.7 14.5 10.5V13.5M18.5 10.5H17V11.5H18.5V13H17V15H15.5V9H18.5V10.5M12 10.5H13V13.5H12V10.5M7 10.5H8V11.5H7V10.5Z" />
				</svg>
			);

		case "plus":
			return (
				<svg
					fill="currentColor"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24">
					<path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
				</svg>
			);

		case "panorama-horizontal":
			return (
				<svg
					fill="currentColor"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24">
					<path d="M12 5.5C8.1 5.5 5.1 4.7 3.3 4.1C2.7 3.8 2 4.3 2 5V19C2 19.7 2.7 20.2 3.3 20C5.4 19.3 8.1 18.5 12 18.5C15.9 18.5 18.7 19.3 20.7 20C21.4 20.2 22 19.7 22 19V5C22 4.3 21.3 3.8 20.7 4.1C18.7 4.7 15.9 5.5 12 5.5Z" />
				</svg>
			);

		case "panorama-vertical":
			return (
				<svg
					fill="currentColor"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24">
					<path d="M18.5 12C18.5 8.1 19.3 5.1 19.9 3.3C20.1 2.7 19.7 2 19 2H5C4.3 2 3.8 2.7 4.1 3.3C4.7 5.4 5.5 8.1 5.5 12C5.5 15.9 4.7 18.7 4.1 20.7C3.8 21.3 4.3 22 5 22H19C19.7 22 20.2 21.3 20 20.7C19.3 18.7 18.5 15.9 18.5 12Z" />
				</svg>
			);

		case "square-rounded":
			return (
				<svg
					fill="currentColor"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24">
					<path d="M8 3H16C18.76 3 21 5.24 21 8V16C21 18.76 18.76 21 16 21H8C5.24 21 3 18.76 3 16V8C3 5.24 5.24 3 8 3Z" />
				</svg>
			);

		case "close":
			return (
				<svg
					fill="currentColor"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24">
					<path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
				</svg>
			);

		case "chevron-double-left":
			return (
				<svg
					fill="currentColor"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24">
					<path d="M18.41,7.41L17,6L11,12L17,18L18.41,16.59L13.83,12L18.41,7.41M12.41,7.41L11,6L5,12L11,18L12.41,16.59L7.83,12L12.41,7.41Z" />
				</svg>
			);

		case "chevron-double-right":
			return (
				<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
					<path d="M5.59,7.41L7,6L13,12L7,18L5.59,16.59L10.17,12L5.59,7.41M11.59,7.41L13,6L19,12L13,18L11.59,16.59L16.17,12L11.59,7.41Z" />
				</svg>
			);

		case "menu-down":
			return (
				<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
					<path d="M7,10L12,15L17,10H7Z" />
				</svg>
			);

		case "loading":
			return (
				<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
					<path d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
				</svg>
			);

		case "delete":
			return (
				<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
					<path d="M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M9,8H11V17H9V8M13,8H15V17H13V8Z" />
				</svg>
			);

		default:
			return null;
	}
}
